module.exports = __webpack_public_path__ + "img/food_welcome_opt.613313b8.jpg";